import { useEffect } from "react";
import { useBikeStore } from "../store/useBikeStore";
import { useVehicleCategoryStore } from "../store/useVehicleCategoryStore";
import { useCountryStore } from "../store/useCountryStore";
import { useCityStore } from "../store/useCityStore";
import { useAuth } from "./useAuth";
import { isFleetScopedRole } from "../utils/authRoles";

export function useResourceBootstrap() {
  const { user, isAuthenticated } = useAuth();
  const { refreshBikes } = useBikeStore();
  const { refreshCategories } = useVehicleCategoryStore();
  const { refreshCountries } = useCountryStore();
  const { refreshCities } = useCityStore();

  useEffect(() => {
    if (!isAuthenticated || !user) return;
    const fleetScoped = isFleetScopedRole(user.role);
    const tasks = [refreshBikes(), refreshCategories()];
    if (!fleetScoped) {
      tasks.push(refreshCountries(), refreshCities());
    }
    Promise.all(tasks).catch(console.error);
  }, [
    refreshBikes,
    refreshCategories,
    refreshCountries,
    refreshCities,
    user,
    isAuthenticated,
  ]);
}
